import React, { FC, ReactElement, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Auth from '@aws-amplify/auth';

import * as paths from 'paths';
import { useGlobalClient, useLocalStorage } from 'hooks';
import { Loaders } from 'components';

import { PasswordlessToken } from '../types';
import { USER_DISABLED } from '../constants';

interface IProps {
  children: ReactElement;
}

const TokenCheck: FC<IProps> = ({ children }) => {
  const client = useGlobalClient();
  const history = useHistory();

  const [newUserSignUpWorkflow, setNewUserSignUpWorkflow] = useLocalStorage('newUserSignUp', false);
  const urlParams = new URLSearchParams(window.location.search);
  const [token, setToken] = useState(urlParams.get('token'));
  let targetPath = urlParams.get('path') || '/';
  urlParams.delete('token');
  if (urlParams.toString()) {
    targetPath += '?' + urlParams.toString();
  }
  const newUserSignUpWorkflowQueryParam =
    urlParams.get('newUserSignUpWorkflow') || newUserSignUpWorkflow || false;

  useEffect(() => {
    void processToken();
    setNewUserSignUpWorkflow(castQueryParam(newUserSignUpWorkflowQueryParam));
  }, [token, client?.id]);

  function castQueryParam(queryParam: any) {
    if (typeof queryParam !== 'string') {
      return queryParam;
    }
    return JSON.parse(queryParam.toLowerCase());
  }
  async function processToken() {
    if (!token) {
      return;
    }
    try {
      await Auth.signOut();
      const publicContent = JSON.parse(atob(token)) as PasswordlessToken;
      const cognitoUser = await Auth.signIn(publicContent.email, null);
      const clientMetadata = client ? { client_id: client.id } : { is_multi_client: 'true' };
      await Auth.sendCustomChallengeAnswer(cognitoUser, publicContent.answer, clientMetadata);
      await Auth.currentSession();
      history.replace(targetPath);
    } catch (error) {
      if (error.message === USER_DISABLED) {
        history.replace(`${paths.authError}?code=passwordlessLinkExpired`);
      } else {
        history.replace(`${paths.authError}?code=passwordlessLinkExpired`);
      }
    } finally {
      setToken(null);
    }
  }

  if (token) {
    return <Loaders.Startup />;
  }

  return children;
};

export default TokenCheck;
